export const getTemplateRowSx = ({
  isDragging,
  isDragOver,
  showCheckbox,
  editing
}) => ({
  opacity: isDragging ? 0.55 : 1,

  transition: 'opacity 0.2s ease, background-color 0.2s ease',

  cursor: showCheckbox && !editing
    ? 'pointer'
    : 'default',

  '&:last-child .MuiTableCell-root': {
    borderBottom: 'none'
  },

  ...(isDragOver && {
    '& .MuiTableCell-root': {
      bgcolor: '#FCF8F2',
      borderTop: '2px solid #C39751'
    }
  })
});

export const checkboxCellSx = {
  width: 45,
  minWidth: 45,
  maxWidth: 45,

  px: 1,
  py: 0,

  bgcolor: 'inherit'
};

export const checkboxSx = {
  p: 0.25,
  color: '#4A90D9',

  '&.Mui-checked': {
    color: '#4A90D9'
  },

  '& .MuiSvgIcon-root': {
    fontSize: 21
  }
};

export const getTextCellSx = ({
  showCheckbox,
  editing
}) => ({
  minWidth: 0,

  px: showCheckbox ? 1 : 1.5,

  py: editing ? 0.5 : 1.25,

  bgcolor: 'inherit'
});

export const topicTextRowSx = {
  width: '100%',
  minWidth: 0,

  fontSize: 13,
  fontWeight: 400,
  lineHeight: 1.45,

  whiteSpace: 'normal',
  overflowWrap: 'break-word',
  wordBreak: 'normal'
};

export const actionCellSx = {
  width: 82,
  minWidth: 82,
  maxWidth: 82,

  px: 1,
  py: 0,

  bgcolor: 'inherit'
};

export const actionWrapperRowSx = {
  justifyContent: 'flex-end'
};

export const dragIconButtonSx = {
  color: '#9E9E9E',
  cursor: 'grab',

  '&:hover': {
    bgcolor: '#F5F5F5',
    color: '#757575'
  },

  '&:active': {
    cursor: 'grabbing'
  }
};